import { GitBranch } from "lucide-react";
import {
  ProblemTreeParamsSchema,
  defaultProblemTreeParams,
  type ProblemTreeParams,
} from "@playbookai/widget-schemas";
import type { WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { ProblemTreeWidget } from "./Component.js";

export const problemTreeDef: WidgetDef<ProblemTreeParams> = {
  kind: "problemTree",
  label: "Problem Tree",
  modes: ["canvas"],
  singleton: true,
  defaultSize: { w: 752, h: 584 },
  defaultParams: defaultProblemTreeParams,
  Component: ProblemTreeWidget,
  storage: "sql",
  schema: ProblemTreeParamsSchema,
  accent: "amber",
  icon: GitBranch,
  subtitle: "Effects · Problem · Root causes",
  defaultRoster: true,
  category: "single",
  layout: { col: "full", row: 2, width: 752, height: 560 },
  expandable: true,
  renderFooter: (data) => ({
    left: `${visibleCount(data.effects.length)} effects · ${visibleCount(data.causes.length)} causes`,
    right: "Tree with roots",
  }),
};

registerWidget(problemTreeDef);

function visibleCount(count: number): number {
  return count > 0 ? count : 3;
}
